import script from "./user.vue?vue&type=script&lang=ts&setup=true"
export * from "./user.vue?vue&type=script&lang=ts&setup=true"

import "./user.vue?vue&type=style&index=0&id=7be75968&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be75968"]])

export default __exports__